export default __webpack_public_path__ + "static/media/ace-logo-tsp.a8c8baf3.png";